<div class="min-h-screen flex flex-col">
  <app-navbar></app-navbar>
  <main class="flex-1 pt-16">
    <router-outlet></router-outlet>
  </main>
  <app-footer></app-footer>
</div>